import { theme } from '@pairy/styles';
import styled from '@emotion/styled';

export const Wrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

interface SelectProps {
  width?: string;
  paddingX?: number;
  paddingY?: number;
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
  marginLeft?: number;
  radius?: number;
  textVariant?: string;
  isError?: boolean;
}

export const Select = styled.select<SelectProps>`
  display: flex;
  width: ${({ width }) => width || '100%'};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ paddingY = 8, paddingX = 16 }) =>
    `${paddingY}px ${paddingX}px`};
  margin: ${({
    marginTop = 0,
    marginRight = 0,
    marginBottom = 0,
    marginLeft = 0,
  }) => `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`};

  border-radius: ${({ radius = 4 }) => `${radius}px`};
  appearance: none;

  ${({ textVariant = 'md-regular' }) => {
    const [sizeKey, weightKey] = textVariant.split('-');
    return `
      font-size: ${theme.fontSize[sizeKey as keyof typeof theme.fontSize]};
      line-height: ${
        theme.lineHeight[sizeKey as keyof typeof theme.lineHeight]
      };
      font-weight: ${
        theme.fontWeight[weightKey as keyof typeof theme.fontWeight]
      };
    `;
  }}

  background-color: ${({ isError }) =>
    isError ? theme.colors.cerise_50 : theme.colors.zinc_50};
  color: ${theme.colors.zinc_500};
  border: 1px solid
    ${({ isError }) =>
      isError ? theme.colors.cerise_500 : theme.colors.zinc_200};

  &::placeholder {
    color: ${theme.colors.zinc_400};
    font-weight: 300;
  }

  &:focus {
    outline: none;
    border-color: ${theme.colors.skyblue_500};
  }
`;
